export default {
  name: 'LocalDataFunctions',
  data: function () {
    return {
    }
  },
  methods: {
    getFromLocal(location) {
      let temp = this.$localStorage.get(location);
      if (temp)
        return JSON.parse(temp);
      else
        return null;
    },
    saveToLocal(location, item) {
      this.$localStorage.set(location, JSON.stringify(item));
    },
    removeFromLocal(location) {
      if (this.$localStorage.get(location))
        this.$localStorage.remove(location);
    }
  }
}


